'use client';
import React from 'react';

export default function RideWithMdeliva() {
  return (
    <section className="py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div
          className="rounded-2xl p-8 border"
          style={{
            background: '#111111',
            borderColor: '#1e1e1e',
          }}
        >
          {/* Icon */}
          <div className="text-3xl mb-4">🚴</div>

          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
            Ride with Mdeliva
          </h2>
          <p className="text-gray-400 text-sm mb-6 max-w-lg">
            Earn on your own schedule. Daily payouts, bonus rewards for top riders, and a community that has your back. Scan QR codes to confirm deliveries and earn extra points.
          </p>

          <button
            className="flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-white text-sm transition-all duration-200 hover:scale-105"
            style={{ background: 'linear-gradient(135deg, #22c55e, #16a34a)' }}
          >
            Start riding →
          </button>
        </div>
      </div>
    </section>
  );
}
